import * as React from 'react'
import HomeItemTag from '../HomeItemListItem/HomeItemTag'
import * as HomeCardViewItemStyle from './HomeCardViewItem.style'
import HomeType from '../../types/HomeType'
import { classes } from 'typestyle'
import * as Styles from '../HomeGuessYouLike/HomeGuessYouLike.style'
import { renderPopular } from '../../../../utils/tools'
// tslint:disable-next-line
import { ImageView } from '../ImageView/ImageView'
import { reportClickEvent, reAssemblyUbt, ViewingMonitor } from '@weike/operation-report'
import { RegisterElement } from '../../../../services/hotspotReport'

interface HomeCardViewItemProp {
  index: number
  content: HomeType.Content
  moduleid: number
  moduleName: string
}

function HomeCardItemView(props: HomeCardViewItemProp) {
  const content = props.content
  const { moduleid, moduleName, index } = props

  const renderLectureTag = () => {
    if (content.image_mode === 'ppt' && content.lecture_mode === 'default') {
      return <HomeItemTag text={'PPT'} />
    }
    if (content.lecture_mode === 'default') {
      switch (content.image_mode) {
        case 'video':
          return <HomeItemTag text={'视频'} />
        case 'audio':
          return <HomeItemTag text={'音频'} />
        default:
          return true
      }
    } else {
      switch (content.lecture_mode) {
        case 'video':
          return <HomeItemTag text={'视频'} />
        case 'audio':
          return <HomeItemTag text={'音频'} />
        default:
          return true
      }
    }
  }

  //  tslint:disable: noImplicitReturns
  const renderTag = () => {
    if (content.type && content.type === 'lecture' && !content.is_preffered) {
      renderLectureTag()
    }
  }

  const renderPrice = () => {
    if (content.need_money) {
      if (content.has_limitmoney) {
        if (Number(content.limit_money) === 0 || content.limit_money === '') {
          return <span>限时免费</span>
        } else {
          return (
            <p>
              <i>￥</i>
              {content.limit_money.split('.')[0]}
              <span style={{ fontSize: 12 }}>.{content.limit_money.split('.')[1]}</span>
            </p>
          )
        }
      } else {
        return (
          <p>
            <i>￥</i>
            {content.lecture_money.split('.')[0]}
            <span style={{ fontSize: 12 }}>.{content.lecture_money.split('.')[1]}</span>
          </p>
        )
      }
    } else {
      return <span className={HomeCardViewItemStyle.HomeCardViewItemFreeText}>免费</span>
    }
  }

  const clickItemsHandle = (contents: HomeType.Content) => {
    reportClickEvent(`feed__${props.moduleid}`, {
      index,
      url: contents.url,
      ch_id: contents.id,
      inviter_id: contents.inviter_id,
      context: moduleName
    })
    setTimeout(() => {
      window.location.href = contents.url
    }, 150)
  }

  return (
    <ViewingMonitor
      ubt={reAssemblyUbt(`feed__${props.moduleid}`)}
      params={{
        index,
        url: content.url,
        ch_id: content.id,
        inviter_id: content.inviter_id,
        context: moduleName
      }}
    >
      <div className={HomeCardViewItemStyle.cardViewWrap} data-growing-title={content.name}>
        <div className={HomeCardViewItemStyle.cardViewItem} onClick={() => clickItemsHandle(content)}>
          <div style={{ position: 'relative' }}>
            <div className={HomeCardViewItemStyle.Cover}>
              <ImageView url={content.cover_url ? content.cover_url : content.cover} width={400} />
            </div>
            <div className={Styles.statusLine} style={{ height: 30 }}>
              <span>
                <img style={{ width: 12, height: 12 }} src="https://static-1253442168.image.myqcloud.com/picture/9485074_b7c94067627a5f97f2b0a14a4d8e05be.jpg" />
                <p className={Styles.statusLineNum}>{renderPopular(content.popular)}次</p>
              </span>
            </div>
          </div>
          <div className={HomeCardViewItemStyle.contentArea}>
            <div className={classes(HomeCardViewItemStyle.titleArea, 'TextChangeToTwoLines')}>
              <div className="tags">
                {content.is_preffered && (
                  <div className={HomeCardViewItemStyle.youXuanType}>
                    <img src="https://static-1253442168.image.myqcloud.com/picture/10490565_2851c8d7884e28dd13a5119f3f0afe89.jpg" alt="" />
                  </div>
                )}
                {content.type && content.type === 'lecture' && !content.is_preffered && renderTag()}
                {content.name}
              </div>
            </div>
            {/* <div className={HomeCardViewItemStyle.cardViewBottom}>
                        <div className={HomeCardViewItemStyle.itemStatus}>
                            {showLeftBottomInfo()}
                        </div>

                    </div> */}
            <div className={HomeCardViewItemStyle.PriceArea}>
              <div className={HomeCardViewItemStyle.realPrice}>{renderPrice()}</div>
              {content.has_limitmoney && Number(content.limit_money) > 0 && content.stype !== 'coupon' && (
                <div className={HomeCardViewItemStyle.originPrice}>¥{content.lecture_money}</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </ViewingMonitor>
  )
}

export default HomeCardItemView



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeCardView/HomeCardViewItem.tsx